<template>
    <div class="card">
        <div class="card-body">
            <h5>انتقال درآمد به کیف پول</h5>
            <p class="mt-4">درآمد قابل انتقال: {{ $helper.formatPrice(income) }} تومان </p>
            <b-button @click="showAlert" variant="success">انتقال درآمد</b-button>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "transfer-income-to-wallet",
    props: {
        income: {
            type: [String, Number],
            required: true
        }
    },
    methods: {
        showAlert() {
            Swal.fire({
                title: `انتقال درآمد به کیف پول`,
                text: 'آیا از انتقال درآمد به کیف پول اطمینان دارید؟',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#34c38f',
                confirmButtonColor: '#f46a6a',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر'
            }).then(result => {
                if (result.value) {
                    this.transferRequest()
                }
            })
        },
        transferRequest() {
            this.$axios.get('financial/transfer-income-to-wallet')
                .then(() => {
                    Swal.fire('موفق!', `عملیات با موفقیت انجام شد`, 'success')
                    this.$emit('income_transfer')
                })
        }
    }
}
</script>
